/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type SortAttributeNames = 'Created' | 'Rating' | 'Views' | 'Display Name' | 'Score';

export const SortAttributeNames = {
    Created: 'Created' as SortAttributeNames,
    Rating: 'Rating' as SortAttributeNames,
    Views: 'Views' as SortAttributeNames,
    DisplayName: 'Display Name' as SortAttributeNames,
    Score: 'Score' as SortAttributeNames
};